import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, first } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

export interface Props {
    model: models.VerificacionViajeEADDto;
    viaje: models.ViajeEADDto;
}

export class ResumenVerificacionViaje extends React.PureComponent<Props>{
    render() {
        const x = this.props.model;
        const y = this.props.viaje;
        return (
            <kea.Panel title={"Resumen del viaje " + y.Folio} >
                {
                    kea.autogrid(3, [
                        <h4 style={{ color: "blue" }}>
                            <label>Importe a entregar:</label>{" "}{kea.formatCurrency(x.ImporteContado)}
                        </h4>,
                        <h4>
                            <label>Efectivo:</label>{" "}{kea.formatCurrency(x.ImporteEfectivo)}
                        </h4>,
                        <h4>
                            <label>Cheque:</label>{" "}{kea.formatCurrency(x.ImporteCheque)}
                        </h4>,
                        <h4 style={{color: "#4A9130"}}>
                            <label>A crédito:</label>{" "}{kea.formatCurrency(x.ImporteCredito)}
                        </h4>,
                    ])
                }

                <h4>
                    <label>Acuses firmados:</label>{" "}{x.AcusesFirmados.length}
                </h4>
                {
                    kea.autogrid(3, [
                        <span>
                            <label>Status del viaje:</label>{" "}{models.StatusViajeEAD[y.Status]}
                        </span>,
                        <span>
                            <label>Guias entregadas:</label>{" "}{x.GuiasEntregadas.length}
                        </span>,
                        <span>
                            <label>Guias rechazadas:</label>{" "}{x.GuiasRechazadas.length}
                        </span>,
                        <span>
                            <label>Guias no entregadas:</label>{" "}{x.GuiasEntregaIncompleta.length}
                        </span>,
                        <span>
                            <label>Entregas incompletas:</label>{" "}{x.GuiasEntregaIncompleta.length}
                        </span>,
                        <span>
                            <label>Ruta del viaje:</label>{" "}{y.NombreRuta}
                        </span>,
                        <span>
                            <label>Chofer del viaje:</label>{" "}{y.NombreChofer}
                        </span>,
                        <span>
                            <label>Camión del viaje:</label>{" "}{y.NombreCamion}
                        </span>,
                        <span>
                            <label>Fecha de salida del viaje:</label>{" "}{kea.formatDate(y.FechaInicio)}
                        </span>,
                        <span>
                            <label>Fecha de llegada del viaje:</label>{" "}{kea.formatDate(y.FechaLlegadaPendienteDescarga)}
                        </span>,
                    ])
                }

            </kea.Panel>
        )
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajesEAD/verificar/resumen.tsx